var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import StorageBlueprint from "./blueprint";
var CookieStorage = /** @class */ (function (_super) {
    __extends(CookieStorage, _super);
    function CookieStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookieStorage.prototype.isAvailable = function () {
        return (typeof document !== "undefined" && typeof document.cookie === "string");
    };
    CookieStorage.prototype.set = function (key, value, options) {
        var expires = options === null || options === void 0 ? void 0 : options.expires;
        var maxAge = options === null || options === void 0 ? void 0 : options.maxAge;
        var path = (options === null || options === void 0 ? void 0 : options.path) || "/";
        var domain = options === null || options === void 0 ? void 0 : options.domain;
        var sameSite = options === null || options === void 0 ? void 0 : options.sameSite;
        var secure = (options === null || options === void 0 ? void 0 : options.secure) || false;
        var cookie = "".concat(encodeURIComponent(this.getKey(key)), "=").concat(encodeURIComponent(value));
        if (maxAge) {
            cookie += "; max-age=" + maxAge;
        }
        else if (expires) {
            cookie += "; expires=" + expires;
        }
        if (path) {
            cookie += "; path=" + path;
        }
        if (domain) {
            cookie += "; domain=" + domain;
        }
        if (sameSite) {
            cookie += "; samesite=" + sameSite;
        }
        if (secure) {
            cookie += "; secure";
        }
        document.cookie = cookie;
    };
    CookieStorage.prototype.get = function (key) {
        var match = document.cookie.match(new RegExp("(?:^|; )".concat(encodeURIComponent(this.getKey(key)), "=([^;]*)")));
        return match ? decodeURIComponent(match[1]) : null;
    };
    CookieStorage.prototype.remove = function (key) {
        document.cookie = "".concat(encodeURIComponent(this.getKey(key)), "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT");
    };
    return CookieStorage;
}(StorageBlueprint));
export default CookieStorage;
//# sourceMappingURL=cookie.js.map